import type { LoadableType } from '@confluence/loadable';
import { LoadableBackground } from '@confluence/loadable';
import type { CollaborationBriefPanelProps } from './useCollaborationBrief.ts';

// Loadable-wrapped export, consistent with other experiment packages
export const CollaborationBriefPanel: LoadableType<CollaborationBriefPanelProps> =
	LoadableBackground({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-CollaborationBriefPanel" */ './CollaborationBriefPanel.tsx'
				)
			).CollaborationBriefPanel,
	});
